module.exports = __webpack_public_path__ + "img/527.803de062.png";